import type { EditorCommand } from '@atlaskit/editor-common/types';
import type { AddBackendRemixHistoryStackEntryPayload } from '@atlassian/malleable-ui-components/types';

import {
	type RemixHistoryPluginMeta,
	remixHistoryPluginKey,
} from '../pm-plugins/remix-history/remix-history-plugin';

export function makeAddBackendRemixHistoryStackEntryCommand(
	options: AddBackendRemixHistoryStackEntryPayload,
): EditorCommand {
	return ({ tr }) => {
		tr.setMeta(remixHistoryPluginKey, {
			type: 'addBackendHistoryStackEntry',
			payload: options,
		} satisfies RemixHistoryPluginMeta);
		return tr;
	};
}
